module.exports = __webpack_public_path__ + "static/img/icon3.07d14c67.svg";